export default "__VITE_ASSET__2wL2oKty__"